import * as ko from "knockout";
import {nsFa} from "../fa/fn";
import ifa = nsFa.ifa;
import tooltipHtml from './tooltip.html?raw';

export let template: string = tooltipHtml;

interface IParams {
    content: string
    side?: "right" | "left"
    icon?: string
}

export class viewModel {

    private static _counter = 0;
    private content: string | null;
    private icon: string;
    private side: KnockoutObservable<'right' | 'left' | null> = ko.observable(null);
    private uniqueId: string;

    constructor(params?: IParams) {
        this.side(params?.side ?? null);
        this.content = params?.content || null;
        this.icon = ifa(params?.icon || 'fa-question-circle');
        viewModel._counter++;
        this.uniqueId = "tt_" + viewModel._counter;
    }

    doPositioning() {
        const $el = document.getElementById(this.uniqueId);
        if (!$el) {
            return;
        }
        const bodyWidth = document.body.getBoundingClientRect().width;
        const x = $el.getBoundingClientRect().x + $el.getBoundingClientRect().width / 2;
        const side = x >= bodyWidth / 2 ? 'left' : 'right';
        this.side(side);
    }
}
